/* INTEGY V775: progressive enhancement for collection discoverability. */
(function(){
'use strict';
var root=document.documentElement;
var script=document.querySelector('script[data-integy-v775-index]');
if(!script)return;
var indexURL=script.getAttribute('data-integy-v775-index');
var loaded=null,pending=null,timer=0;
function load(){
 if(loaded)return Promise.resolve(loaded);
 if(pending)return pending;
 pending=fetch(indexURL,{credentials:'same-origin',cache:'force-cache'}).then(function(r){if(!r.ok)throw Error('index unavailable');return r.json();})
 .then(function(rows){loaded=Array.isArray(rows)?rows.filter(function(x){return x&&/^[a-z0-9-]+$/.test(x.handle)&&typeof x.title==='string';}):[];return loaded;})
 .catch(function(){loaded=[];return loaded;});
 return pending;
}
function norm(s){return String(s||'').toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();}
function match(q){
 var terms=norm(q).split(' ').filter(function(x){return x.length>1;});
 if(!terms.length)return[];
 return (loaded||[]).filter(function(x){var t=norm(x.title);return terms.every(function(w){return t.indexOf(w)>=0;});}).slice(0,70);
}
function link(item){var a=document.createElement('a');a.href='/collections/'+item.handle;a.textContent=item.title;return a;}
function browseHref(q){return '/search?type=product&q='+encodeURIComponent(q)+'#integy-v775-matching-collections';}
function full(){
 if(!/\/search\/?$/i.test(location.pathname))return;
 var q=new URLSearchParams(location.search).get('q')||'';
 if(norm(q).length<3)return;
 load().then(function(){
   if(document.getElementById('integy-v775-matching-collections'))return;
   var found=match(q);
   if(!found.length)return;
   var section=document.createElement('section');
   section.id='integy-v775-matching-collections';
   section.className='integy-v775-collection-discovery';
   section.setAttribute('aria-label','Matching product collections');
   var crumb=document.createElement('nav');crumb.className='integy-v775-inline-breadcrumb';crumb.setAttribute('aria-label','Breadcrumb');
   var homeLink=document.createElement('a');homeLink.href='/';homeLink.textContent='Home';crumb.appendChild(homeLink);
   var divider=document.createElement('span');divider.textContent=' › ';divider.setAttribute('aria-hidden','true');crumb.appendChild(divider);
   var label=document.createElement('span');label.setAttribute('aria-current','page');label.textContent='Search results for “'+q+'”';crumb.appendChild(label);
   section.appendChild(crumb);
   var h=document.createElement('h2');h.textContent='Browse matching collections ('+found.length+')';section.appendChild(h);
   var p=document.createElement('p');p.textContent='These are collection destinations, separate from product search results. Browse a category to narrow by brand, pitch, model or part type.';section.appendChild(p);
   var grid=document.createElement('div');grid.className='integy-v775-collection-grid';
   found.forEach(function(item){grid.appendChild(link(item));});section.appendChild(grid);
   var target=document.querySelector('.integy-v437-search-collections');
   if(target){target.insertAdjacentElement('afterend',section);return;}
   target=document.querySelector('body.template-search .productgrid--outer,body.template-search .search--section .productgrid--items');
   if(target){target.parentNode.insertBefore(section,target);return;}
   target=document.querySelector('body.template-search main,body.template-search .site-main');
   if(target)target.insertBefore(section,target.firstChild);
 });
}
function ensureSearchBreadcrumb(){
 if(!/\/search\/?$/i.test(location.pathname))return;
 var existing=Array.prototype.some.call(document.querySelectorAll('nav.breadcrumbs-container'),function(e){return e.getClientRects().length>0;});
 if(existing||document.querySelector('.integy-v775-search-breadcrumb'))return;
 var target=document.querySelector('.integy-v437-search-collections')||document.getElementById('integy-v775-matching-collections')||document.querySelector('body.template-search .productgrid--outer');
 if(!target||!target.parentNode)return;
 var nav=document.createElement('nav');nav.className='breadcrumbs-container integy-v775-search-breadcrumb';nav.setAttribute('aria-label','Breadcrumb');
 var a=document.createElement('a');a.href='/';a.textContent='Home';nav.appendChild(a);
 var divider=document.createElement('span');divider.textContent=' › ';divider.setAttribute('aria-hidden','true');nav.appendChild(divider);
 var current=document.createElement('span');current.setAttribute('aria-current','page');
 var q=new URLSearchParams(location.search).get('q')||'';
 current.textContent=q?'Search results for “'+q+'”':'Search';nav.appendChild(current);
 target.parentNode.insertBefore(nav,target);
}
function quick(input){
 if(document.activeElement!==input)return;
 var q=String(input.value||'').trim();
 var form=input.closest('form');if(!form||norm(q).length<3){if(form){var old=form.querySelector('[data-integy-v775-quick]');if(old)old.remove();}return;}
 load().then(function(){
   if(document.activeElement!==input||input.value.trim()!==q)return;
   var found=match(q),old=form.querySelector('[data-integy-v775-quick]');
   if(!found.length){if(old)old.remove();return;}
   var natural=form.querySelector('[data-live-search-flydown],.search-flydown');
   var nativePanel=document.getElementById('integy-v520-search-panel');
   var parent=(nativePanel&&nativePanel.offsetParent!==null?nativePanel:(natural&&natural.offsetParent!==null?natural:form));
   if(old&&old.parentElement!==parent)old.remove();
   var div=parent.querySelector('[data-integy-v775-quick]');
   if(!div){div=document.createElement('div');div.setAttribute('data-integy-v775-quick','');div.className='integy-v775-quick-collections';parent.appendChild(div);}
   div.classList.toggle('integy-v775-search-fallback',parent===form);
   div.replaceChildren();
   var h=document.createElement('strong');h.textContent='Matching collections ('+found.length+')';div.appendChild(h);
   found.slice(0,7).forEach(function(x){div.appendChild(link(x));});
   if(found.length>7){var more=document.createElement('a');more.href=browseHref(q);more.textContent='View all '+found.length+' matching collections';div.appendChild(more);}
 });
}
function isHeaderInput(input){return input&&input.matches&&input.matches('.live-search-form input[name="q"],.site-header input[type="search"][name="q"]');}
document.addEventListener('input',function(e){if(!isHeaderInput(e.target))return;var input=e.target;clearTimeout(timer);timer=setTimeout(function(){quick(input);},340);},true);
document.addEventListener('focusin',function(e){if(isHeaderInput(e.target)&&norm(e.target.value).length>=3)quick(e.target);},true);
document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;document.querySelectorAll('[data-integy-v775-quick]').forEach(function(x){x.remove();});});
document.addEventListener('focusout',function(e){if(!isHeaderInput(e.target))return;var form=e.target.closest('form');setTimeout(function(){if(form&&!form.contains(document.activeElement)){var p=form.querySelector('[data-integy-v775-quick]');if(p)p.remove();}},210);},true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){full();ensureSearchBreadcrumb();},{once:true});else{full();ensureSearchBreadcrumb();}
})();